// extracted by mini-css-extract-plugin
export var container = "_76-0";
export var error = "_76-9";
export var label = "_76-5";
export var light = "_76-6";
export var md = "_76-3";
export var sm = "_76-2";
export var thin = "_76-8";
export var thinBold = "_76-7";
export var vertical = "_76-4";
export var xs = "_76-1";